import FullPageLoader from "../../components/full-page-loader";
import useBridgeFlow from "./useBridgeFlow";
import Screen from "../../layout/screen";

const BridgeFlow = () => {
  const { isReady } = useBridgeFlow();
  if (isReady) {
    return <Screen />;
  }
  return <FullPageLoader />;
};

export default BridgeFlow;
